"use strict";
// Reusable Stevie Images for tiles
Object.defineProperty(exports, "__esModule", { value: true });
exports.spritesPieces = void 0;
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var minigolfLayers_sidecar_1 = require("../scene/minigolfLayers-sidecar");
exports.spritesPieces = imageRecycler_sidecar_1.imageRecycler.create('minigolf-pieces', function () { return minigolfLayers_sidecar_1.minigolfLayers.getLayers().pieces; });
